'use client';

import { AnimatePresence, motion } from 'framer-motion';
import { Button } from '@salesport/ui-components/Button';
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from '@salesport/ui-components/Card';
import { Link } from '@salesport/ui-components/Link';

import { config } from '../config';
import { ConsentState, useCookiesConsent } from '../useCookiesConsent';

export function CookieBanner() {
  const { cookieState, onAcceptCookies, onRejectCookies } = useCookiesConsent();

  return (
    <AnimatePresence>
      {cookieState && cookieState === ConsentState.PENDING && (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          className="fixed bottom-4 right-4 z-50">
          <Card className="max-w-md p-4 shadow-lg">
            <CardHeader>Cookie Settings</CardHeader>
            <CardBody>
              <p className="text-small text-default-700">
                We use cookies to enhance your experience, analyze site traffic
                and deliver personalized content. Read our{' '}
                <Link
                  href={config.cookiePolicyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="always"
                  size="sm"
                  color="primary">
                  Cookie Policy
                </Link>
                .
              </p>
            </CardBody>
            <CardFooter>
              <div className="flex w-full gap-3">
                <Button
                  color="default"
                  variant="flat"
                  onPress={onRejectCookies}
                  className="flex-1">
                  Reject all
                </Button>
                <Button
                  color="primary"
                  variant="solid"
                  onPress={onAcceptCookies}
                  className="flex-1">
                  Accept all
                </Button>
              </div>
            </CardFooter>
          </Card>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
